import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, catchError, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';
import { ApiPaths } from '../modules/utils/apipath.constants';
@Injectable({ providedIn: 'root' })
export class ConsentService {
  private apiUrl = environment.apiUrl;
  constructor(private apiService: ApiService) {}

  private getAuthId(): string {
    // Try to get from localStorage first
    const storedAuthId = localStorage.getItem('externalAuthId');
    
    // Return stored value or fall back to default
    return storedAuthId ;
  }
  getConsent(country: string): Observable<any> {
    //return this.http.get<string>('/api/terms'); // TODO alexis we dont know where the endpoint is
    //also there will be needed to change the 
    const customHeaders = {
      'Api-Auth-Id': this.getAuthId(),
      'Api-Source-Info': 'eyJFdmVudFNvdXJjZVR5cGUiOiJGYWtlIEV2ZW50U291cmNlVHlwZSIsIkV2ZW50U291cmNlS2V5IjoiRmFrZSBFdmVudFNvdXJjZUtleSIsIkV2ZW50U291cmNlSXRlbSI6IkZha2UgRXZlbnRTb3VyY2VJdGVtIn0='
    }
    return this.apiService
      .get<any>(ApiPaths.consents.getByCountry(country), undefined , {headers: customHeaders})
      .pipe(
        map((response) => {
        const result = {consents : []};
        if (response && Array.isArray(response) && response.length > 0) {
          
          result.consents = response[0].consents || [];
          
        } else if (response && response.consents) {
          
          result.consents = response.consents || [];
        }
        return result;
      }),
      catchError(error => {
        
        throw error;
      })
    );
  }


  getTermsNPrivacy(sessionCountry: string): Observable<any> {
    //return this.http.get<string>('/api/terms'); // TODO alexis we dont know where the endpoint is
    //also there will be needed to change the 
    const customHeaders = {
      'Api-Auth-Id': this.getAuthId(),
      'Api-Source-Info': 'eyJFdmVudFNvdXJjZVR5cGUiOiJGYWtlIEV2ZW50U291cmNlVHlwZSIsIkV2ZW50U291cmNlS2V5IjoiRmFrZSBFdmVudFNvdXJjZUtleSIsIkV2ZW50U291cmNlSXRlbSI6IkZha2UgRXZlbnRTb3VyY2VJdGVtIn0='
    }
    return this.apiService
      .get<any>(ApiPaths.consents.getTermsAndPrivacy(sessionCountry), undefined , {headers: customHeaders})
      .pipe(
        map((response) => {
        const result = {
            terms: '',
            privacy: '',
            disclaimer: '',
            isHca: false
          }
        if (response && Array.isArray(response) && response.length > 0) {
          if (response[0].consentTermsAndPrivacy) {
            result.terms = response[0].consentTermsAndPrivacy.termsAndConditions || '';
            result.privacy = response[0].consentTermsAndPrivacy.privacyPolicy || '';
            result.isHca = response[0].consentTermsAndPrivacy.isHca || false;
            result.disclaimer = response[0].consentTermsAndPrivacy.protectionInformation || '';
          }
          
          
        } else if (response && response.consents) {
          if (response.consentTermsAndPrivacy) {
            result.terms = response.consentTermsAndPrivacy.termsAndConditions || '';
            result.privacy = response.consentTermsAndPrivacy.privacyPolicy || '';
            result.isHca = response[0].consentTermsAndPrivacy.isHca || false;
            result.disclaimer = response[0].consentTermsAndPrivacy.protectionInformation || '';
          }
         
        }
        return result;
      }),
      catchError(error => {
        console.error("Error fetching consents:", error);
        
        throw error;
      })
    );
  }
  private getMockConsents(country: string): Observable<any[]> {
    // You could have different mock files per country, or
    // filter the mock data based on country
    return this.apiService
      .get<{consents: any[]}>(`../../assets/mock/consents-${country}.json`)
      .pipe(
        map(res => res.consents),
        catchError(() => {
          // If country-specific mock not found, fall back to general mock
          return this.apiService
            .get<{consents: any[]}>('../../assets/mock/consents.json')
            .pipe(map(res => res.consents));
        })
      );
  }

}
